var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-fade-transition", [
    _vm.loading
      ? _c(
          "div",
          {
            staticClass: "cinematic-loader",
            style: { background: _vm.background }
          },
          [
            _c("div", {
              staticClass:
                "cinematic-loader__aurora cinematic-loader__aurora--a"
            }),
            _c("div", {
              staticClass:
                "cinematic-loader__aurora cinematic-loader__aurora--b"
            }),
            _c(
              "div",
              { staticClass: "cinematic-loader__content" },
              [
                _vm.showLogo
                  ? _c(
                      "div",
                      {
                        staticClass: "cinematic-loader__logo-wrap",
                        style: _vm.logoStyle
                      },
                      [
                        _c("img", {
                          staticClass:
                            "cinematic-loader__logo cinematic-loader__logo--ghost",
                          attrs: { src: _vm.logoSource, alt: "" },
                          on: { error: _vm.onImageError }
                        }),
                        _c("img", {
                          staticClass:
                            "cinematic-loader__logo cinematic-loader__logo--fill",
                          attrs: {
                            src: _vm.logoSource,
                            alt: "",
                            "aria-hidden": "true"
                          },
                          on: { error: _vm.onImageError }
                        })
                      ]
                    )
                  : _c("v-progress-circular", {
                      staticClass: "cinematic-loader__spinner",
                      attrs: {
                        indeterminate: "",
                        color: "primary",
                        size: 56,
                        width: 4
                      }
                    })
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }